import { useQuery } from '@apollo/client';
import { GET_TOP_EVENTS } from '@frontend/data-access';
import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import useTranslation from 'next-translate/useTranslation';

interface EventData {
  name: string;
  total: number;
}

function TopEventsStats() {
  const { t } = useTranslation('admin');

  const { data, loading } = useQuery<{
    dashboardTopEvents: EventData[];
  }>(GET_TOP_EVENTS);

  const columns: ColumnsType<EventData> = [
    {
      title: t('no'),
      dataIndex: 'index',
      key: 'index',
      render: (_, __, index) => (
        <span className="text-center">{index + 1}.</span>
      ),
    },
    {
      title: t('event_name'),
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {/* <Avatar shape="square" src={record.image} style={{ marginRight: 8 }} /> */}
          {text}
        </div>
      ),
    },
    {
      title: t('no_of_rsvps'),
      dataIndex: 'total',
      key: 'total',
      align: 'center',
    },
  ];

  return (
    <Table
      rowKey="name"
      columns={columns}
      dataSource={data?.dashboardTopEvents}
      pagination={false}
      loading={loading}
    />
  );
}

export default TopEventsStats;
